import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CurrentSessionService } from 'src/app/shared/services/current-session.service';
import { Report } from '../../report';
import { MerchantReport } from '../../services/merchant-report.service';

@Component({
  selector: 'app-merchant',
  templateUrl: './merchant.component.html',
  styleUrls: ['./merchant.component.scss']
})
export class MerchantComponent implements OnInit {
  tableColumns: string[] = [
    "name",
    "category",
    "facebook",
    "description",
    "totalsales"
  ];
  displayTableColumns = {
    shop_name: 'Name',
    email: 'Category',
    username: 'Facebook',
    num_referred: 'Description',
    success: 'TotalSales'
  };
  requestBody: Report = {};
  loading: boolean = false;
  totalNumberOfRecords = 0;
  adminName: string = ''
  isAssignedBusinessSelected: boolean = false
  merchantReportData: any[] = [];
  isSuperAdmin: boolean =  false

  constructor(
    public merchantReport: MerchantReport,
    private auth: AuthService,
    private getCurrentSessionService: CurrentSessionService,
  ) { }
  async ngOnInit() {
    this.adminName = (await this.auth.getRole()).name
    this.isAssignedBusinessSelected = this.adminName.includes('SuperAdmin') ? false : true;
    this.isSuperAdmin = this.adminName.includes('SuperAdmin') ? false : true;
    this.merchantReport.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      console.log('filter should not be null', event);
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.merchantReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.merchantReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChance(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.merchantReport.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }


  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.merchantReport.loader().subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    this.merchantReport.activateLoader();
    if (this.isAssignedBusinessSelected){
      if(!this.requestBody['filterOptions']){
        this.requestBody['filterOptions'] = {}
      }
      const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
      this.requestBody['filterOptions']['adminId'] = adminId
    } else {
      delete this.requestBody?.filterOptions?.adminId
    }
    this.merchantReport.setParams(this.requestBody);
    const report = await this.merchantReport.make();
    this.merchantReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }

  assignedBusinessesFilterChanged(value){
    this.isAssignedBusinessSelected = value;
  }
}
